// extracted by css-extract-rspack-plugin
export default {"content":"content_DJDtH","layout":"layout_A1kZH"};